import Icon from './Icons';

export const DATA_HEALTH_GUIDANCE_TITLE = 'Data Health';

export function DataHealthGuidanceBody() {
  return (
    <>
      <p>
        Review plants with missing information — 5 at a time. Each card shows a row of field pills. Tap any pill to jump directly to that field, or step through with Next field →.
      </p>
      <p>
        Priority fields — Location, Light Source, Photos — appear first. Optional fields follow. Skip any plant you don't want to review now.
      </p>
    </>
  );
}

// ─── Welcome ─────────────────────────────────────────────────────────────────

export const WELCOME_GUIDANCE_TITLE = 'Your plant collection, properly tracked.';

export function WelcomeGuidanceBody() {
  return (
    <>
      <p>
        Each plant gets its own record: photos, observations, location, care history, and species care profiles.
      </p>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="leaf" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Collection</strong> — your plant roster, with filters and search
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="clock" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Rounds</strong> — guided check-ins, one plant at a time
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="calendar" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Plan</strong> — weekly care schedule and batch tasks
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="sparkles" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Explore</strong> — AI care profiles for species you grow or want
        </span>
      </div>
    </>
  );
}

// ─── Care Rounds ──────────────────────────────────────────────────────────────

export const ROUNDS_GUIDANCE_TITLE = 'Care Rounds';

export function RoundsGuidanceBody() {
  return (
    <>
      <p>
        Check on your plants one at a time. Pick a theme to build your queue, then work through cards at your own pace.
      </p>

      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="clock" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Most Overdue</strong> — longest-untended plants first
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="dice5" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Surprise Me</strong> — weighted shuffle toward neglected plants
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="stone" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>By Growing Method</strong> — all soil, semi-hydro, or water plants
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="mapPin" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>By Location</strong> — one room at a time
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="clipboardCheck" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>By Plant Status</strong> — collection, propagation stock, loaned in
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="tag" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>By Tag</strong> — any custom group you've created
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="sprout" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Propagation Bay</strong> — active cuttings and pre-plant items
        </span>
      </div>

      <div className="rounds-card-actions-list">
        <p className="rounds-card-actions-label">On each card</p>
        <p>Looks Good → logs a health check observation</p>
        <p>+ Observation → choose a care event type (repot, fertilize, treatment, etc.)</p>
        <p>+ Measurement → log height, leaf count, or longest leaf</p>
        <p>Schedule Care → add a future task to Care Plan</p>
        <p>Location → update where the plant lives</p>
        <p>Skip → move to the next plant without logging anything</p>
      </div>
      <p>Tap the plant photo to open a quick detail sheet without leaving the round.</p>
    </>
  );
}

// ─── Care Plan ────────────────────────────────────────────────────────────────

export const PLAN_GUIDANCE_TITLE = 'Care Plan';

export function PlanGuidanceBody() {
  return (
    <>
      <p>Schedule and track care tasks across your collection by day.</p>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="calendar" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Week view</strong> — tap any day to see or complete its tasks
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="list" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Plan a Session</strong> — select plants and assign tasks in bulk
        </span>
      </div>
      <div className="guidance-feature-row">
        <span className="guidance-feature-icon"><Icon name="clock" size={16} /></span>
        <span className="guidance-feature-text">
          <strong>Overdue tasks</strong> surface automatically at the top of the week
        </span>
      </div>
      <p>
        Rounds are live check-ins — pick up your phone and go. Plan is for scheduling care in advance and reviewing what's been assigned.
      </p>
    </>
  );
}
